import EmailConfirmationWrapper from "@/components/EmailConfirmationWrapper";
import { Layout } from "@/components/Layout";
import { PesquisaSatisfacao } from "@/components/PesquisaSatisfacao";
import Agendamentos from "@/pages/app/agendamentos";
import Campanhas from "@/pages/app/campanhas";
import DetalhesCampanha from "@/pages/app/campanhas/detalhes";
import Home from "@/pages/app/Home";
import HistoricoAgendamentos from "@/pages/app/Home/historico";
import NotificationPage from "@/pages/app/notifications/web";
import PerfilPage from "@/pages/app/perfil/web";
import PetCardPage from "@/pages/app/PetCard";
import Pets from "@/pages/app/pets";
import { Navigate, Route, Routes } from "react-router-dom";

export function AppRoutes() {
  return (
    <EmailConfirmationWrapper>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/pet-card" element={<PetCardPage />} />
          <Route path="/pets" element={<Pets />} />
          <Route path="/agendamentos" element={<Agendamentos />} />
          <Route path="/campanhas" element={<Campanhas />} />
          <Route path="/campanhas/:campanhaId" element={<DetalhesCampanha />} />
          <Route path="/historico" element={<HistoricoAgendamentos />} />
          <Route path="/notifications" element={<NotificationPage />} />
          <Route path="/perfil" element={<PerfilPage />} />
          <Route path="*" element={<Navigate to={'/'} />} />
        </Route>
      </Routes>
      <PesquisaSatisfacao />
    </EmailConfirmationWrapper>
  );
} 